// Small shared input sanitisers used across signup + account-info
// forms. Centralised so the rules (letters / spaces / common name
// punctuation) stay consistent everywhere a customer can type a name.

/**
 * Strips anything that isn't a letter, space, hyphen or apostrophe.
 * Keeps "Mary-Jane" and "O'Brien" intact but rejects digits and
 * special characters. Trim whitespace at submit, not here, so the
 * user can still type a trailing space mid-word.
 */
export function sanitizeName(value: string): string {
  return value.replace(/[^A-Za-z\s'-]/g, '');
}

// Strong-password policy for PROFESSIONAL + ADMIN accounts — mirrors the
// server rule (cherry-picked-backend src/Common/password.ts) so the
// client-side check matches exactly what the API will accept. Returns a
// clear error message, or null when the password satisfies every rule.
export const STRONG_PASSWORD_MESSAGE =
  'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number, and a special character (e.g. ! @ # $).';

export function passwordStrengthError(value: string): string | null {
  if (
    !value ||
    value.length < 8 ||
    !/[A-Z]/.test(value) ||
    !/[a-z]/.test(value) ||
    !/\d/.test(value) ||
    !/[^A-Za-z0-9]/.test(value)
  ) {
    return STRONG_PASSWORD_MESSAGE;
  }
  return null;
}
